import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class TargetRatesService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    /**
     * Returns the Yield Curve Data for the Charrt
     *
     * @param dates: dates to request
     */
    getYieldCurveData(datesList) {
        const dates = datesList.join();
        const url = this.urlsService.TARGET_RATES.YIELD_CURVE_DATA;
        return this.ajaxService.getDataObserveBody(url, { dates });
    }
    getChartSaveAsImageUrl(datesList) {
        const baseUrl = this.urlsService.EMBEDS.SAVE_AS_IMAGE_YIELD_CURVE_CHART;
        const dates = datesList.join();
        const state = { dates, redesign: true, partner: 'pdf_yield_curve' };
        const data = formFlattenedObject(state, ['dates', 'redesign', 'partner']);
        return this.ajaxService.postFormEncodedDataObserveResponse(baseUrl, data);
    }
    getYieldCurveUrl(datesList) {
        const chartDataBaseUrl = this.urlsService.TARGET_RATES.YIELD_CURVE_DATA_CSV;
        const dates = datesList.join();
        return this.urlsService.getUrl(chartDataBaseUrl, {}, { dates });
    }
    getIntraDayRatesIndices() {
        const url = this.urlsService.TARGET_RATES.INTRADAY_RATES_DATA;
        return this.ajaxService.getDataObserveBody(url);
    }
    getKeyRatesIndicators() {
        const url = this.urlsService.TARGET_RATES.KEY_RATES_INDICATORS;
        return this.ajaxService.getDataObserveBody(url);
    }
    getDownloadPdf(datesList, showRecessions) {
        const dates = datesList.join();
        const url = this.urlsService.TARGET_RATES.PDF_REPORT;
        const queryParams = {
            dates,
            show_recessions: showRecessions,
        };
        return this.ajaxService.getDataObserveBody(url, queryParams);
    }
}
TargetRatesService.ɵfac = function TargetRatesService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TargetRatesService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
TargetRatesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TargetRatesService, factory: TargetRatesService.ɵfac, providedIn: 'root' });
